var site = site || {};

site.inits = [];

site.device = {};
site.window = {};
site.owl = {};
site.nav = {};
site.sidebar = {};
site.hero = {};
site.search = {};

site.device.isTouch = function() {
	try {
		document.createEvent("TouchEvent");
		return true;
	} catch (e) {
		return false;
	}
};

site.window.scrollPosition = 0;

// Shorthand to init owlcarousel
site.owl.init = function(id, options) {
	var $owl = $(id);
	if ($owl.length > 0) {
		$owl.owlCarousel(options);
	}
};

// Init navigation scripts
site.nav.init = function() {
	// Add expand link to mobile menu
	$('.children', '#mainmenu').prepend('<a class="expand" href="#"><i class="fa fa-angle-down"></i></a>');
	$('.selectedLevel1','#mainmenu').addClass('down');
	$('.selectedLevel2','#mainmenu').addClass('down');
	$('.selectedLevel3','#mainmenu').addClass('down');
	$('.children', '#mainmenu').each(function() {
		$this = $(this);
		$m2 = $this.find('.mmLevel2');
		$m2.css('marginLeft', '-' + ($m2.width()/2 - $this.width()/2) + 'px');
	});

	/*
	var w = window.innerWidth;
	if(w > 1024) {
		$('.children', '#mainmenu').hover(function () {
			$(this).addClass('hover');
		}, function () {
			$(this).removeClass('hover');
		});
	}
	else{
		if(w > 767 && w < 1025) {
			$('.children', '#mainmenu').click(function (e) {
				if(!$(this).hasClass('hover')) {
					e.preventDefault();
				}
				$(this).toggleClass('hover');
			});
		}
	}
	*/

	if (site.device.isTouch && window.innerWidth > 766) {
		$('.children', '#mainmenu').hover(function (e) {
			var $this = $(this)
				hover = false;

			if($this.hasClass('level1') && !$this.hasClass('hover') && $this.filter(':hover').length !== 0) {
				e.preventDefault();
				hover = true;
			}

			// close all
			$('.hover', '#mainmenu').removeClass('hover');

			if (hover) {
				$this.addClass('hover');
			}
		});
	}

	site.nav.bind();
};

// Bind events
site.nav.bind = function() {
	// Mobile menu toggle
	$('#mainmenuToggle').click(function(e) {
		var menuOpen = $('body').hasClass('mainmenu-open');
		if (!menuOpen) {
			site.window.scrollPosition = $(window).scrollTop();
		}
		site.nav.mobileToggle(e, menuOpen, site.window.scrollPosition);
		e.preventDefault();
	});

	// Expand in mobile menu
	$('.expand', '#mainmenu').bind('click', function(e) {
		e.preventDefault();
		var $this = $(this);
		$this.closest('li').toggleClass('down');
	});
	site.nav.appendStuff();
};

// Toggle mobile menu
site.nav.mobileToggle = function(e, menuOpen, scrollPosition) {
	$('body').toggleClass('mainmenu-open');
	$(this).toggleClass('open');
	if (!menuOpen) {
		$(window).scrollTop(0);
		$('i', '#mainmenuToggle').removeClass('fa-bars').addClass('fa-close');
	}
	else {
		$(window).scrollTop(scrollPosition);
		$('i', '#mainmenuToggle').removeClass('fa-close').addClass('fa-bars');
	}
};

// Append language, qn and search
site.nav.appendStuff = function() {
	var $menu = $('ul.mmLevel1', '#mainmenu');

	var $search = $('<div class="mSearch" />');
	$search.append($('form','#searchBox').clone());
	$('#mainmenu').prepend($search);
};

// Append language to mobilemenu
site.nav.appendLanguage = function() {
	var $divisions = $('.menu', '#divisions');
	var $menu = $('ul.mmLevel1', '#mMenu');

	var $html = $('<li class="ele-language si level1"></li>');
	$divisions.find('li').each(function() {
		var $li = $(this).clone();
		$html.append($li.find('a'));
	});

	$menu.append($html);
};

// Bind events
site.search.bind = function() {
	// Mobile menu toggle
	$('#searchToggle').click(function(e) {
		e.preventDefault();
		site.search.searchToggle();
	});
};
// Toggle search
site.search.searchToggle = function() {
	$('body').toggleClass('search-open');
	$(this).toggleClass('open');
	if ($('body').hasClass('search-open')) {
		$('i', '#searchToggle').removeClass('fa-search').addClass('fa-close');
		$('#q').focus();
		$('#searchBox').addClass('slideInDown');
	}
	else {
		$('i', '#searchToggle').removeClass('fa-close').addClass('fa-search');
		$('#searchBox').removeClass('slideInDown');
	}
};

site.coursesMixitup = {
	init: function () {
		var targetSelector = '.course';

		/**
		 * Reads a hash from the URL (if present), and converts it into a class
		 * selector string. E.g "#green" -> ".green". Otherwise, defaults
		 * to the targetSelector, equivalent to "all"
		 *
		 * @return {string}
		 */
		function getSelectorFromHash() {
			var hash = window.location.hash.replace(/^#/g, '');

			var selector = hash ? '.' + hash : targetSelector;

			return selector;
		}

		/**
		 * Updates the URL whenever the current filter changes.
		 *
		 * @param   {mixitup.State} state
		 * @return  {void}
		 */
		function setHash(state) {
			var selector = state.activeFilter.selector;
			var newHash = '#' + selector.replace(/^./g, '');

			if (selector === targetSelector && window.location.hash) {
				// Equivalent to filter "all", remove the hash

				history.pushState(null, document.title, window.location.pathname); // or history.replaceState()
			} else if (newHash !== window.location.hash && selector !== targetSelector) {
				// Change the hash

				history.pushState(null, document.title, window.location.pathname + newHash); // or history.replaceState()
			}
		}

		// Instantiate and configure the mixer
		var mixer = mixitup('.coursesContainer', {
			selectors: {
				target: targetSelector
			},
			animation: {
				enable: false
			},
			load: {
				filter: getSelectorFromHash() // Ensure that the mixer's initial filter matches the URL on startup
			},
			callbacks: {
				onMixEnd: setHash // Call the setHash() method at the end of each operation
			}
		});

		window.onhashchange = function () {
			var selector = getSelectorFromHash();
			if (selector === mixer.getState().activeFilter.selector) return; // no change

			mixer.filter(selector);
		};
	}
};

site.courseColor= {
	init: function () {
		var $classes = $('body').attr('class').split(' ');
		for (var i = 0; i < $classes.length; i++) {
			if ($classes[i].startsWith('color')) {
				var $color = $classes[i].replace('color', '');
				$('#breadcrumbs, .boxTitle h1').css('border-color', $color);
			}
		}
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.search.bind();
	site.nav.init();
	site.labelFocus.init();
	site.owl.init('#reviews > ul', {
		loop:true,
		nav:true,
		navText:["",""],
		items: 1
	});

	if($('body').hasClass('frontpage')) {
		$('.frontpage-mailinglist','#main').wrapInner('<div class="mlistWrap"></div>');
		var $wrap = $('body');
		var h = window.innerHeight;
		var w = window.innerWidth;

		if(w < 768) {
			$(window).on("scroll", function (e) {
				var scroll = $(window).scrollTop();
				if (scroll >= (h/3 - 20)) {
					$wrap.addClass("fillHeader");
				} else {
					$wrap.removeClass("fillHeader");
				}
			});
		}
	}

	// Responsive tables
	if(!$('body').is('.admin')) {
		$('table', '#main').addClass('table').wrap('<div class="table-responsive"></div>');
	}

	$('.box_courses_upcoming .single,#courses .subCategory .single').click(function(e) {
		location.href= $(this).find('.more').attr('href');

	});

	if ($('.coursesContainer').length) {
		site.coursesMixitup.init();
	}

	// Enable specified color in inna:course view
	// if ($('.coursesView').length) {
	// 	site.courseColor.init();
	// }


	// Touch login
	$('.login').bind('click', function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	$li = $('.selected', '#divisions');
	$ul = $('.menu', '#divisions');
	$ul.prepend($li);
});
